const ogImageSize = {
  width: 1200,
  height: 630,
};

export default ogImageSize;
